import {ChecklistQuestionAnswer} from './checklistQuestionAnswer.model';
import {ChecklistModelItem} from './checklistModelItem.model';

export class ChecklistAnswer {
    id: number;
    value: string;
    targetDate: string;
    answerDate: string;
    note: string;
    questionsCount: number;
    completedCount: number;
    checklistModelItem: ChecklistModelItem;
    checklistAnswerGroupId: number;
    questionAnswers: Array<ChecklistQuestionAnswer> = [];

    constructor(checklistAnswer: any) {
        if (checklistAnswer) {
            this.id = checklistAnswer.id;
            this.value = checklistAnswer.value;
            this.targetDate = checklistAnswer.targetDate;
            this.answerDate = checklistAnswer.answerDate;
            this.note = checklistAnswer.note;
            this.questionsCount = checklistAnswer.questionsCount;
            this.completedCount = checklistAnswer.completedCount;
            this.checklistModelItem = new ChecklistModelItem(checklistAnswer.checklistModelItem);
            this.checklistAnswerGroupId = checklistAnswer.checklistAnswerGroupId;
            if (checklistAnswer.questionAnswers) {
                checklistAnswer.questionAnswers.forEach(questionAnswer => {
                    this.questionAnswers.push(new ChecklistQuestionAnswer(questionAnswer));
                });
            }
        }
    }
}